/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { TradingSummaryViewProps } from "./trading-summary.types";
import { TradingSummaryFilter } from "./trading-summary-filter";
import { TradingSummaryHeader } from "./trading-summary-header";
import { TradingSummaryTable } from "./trading-summary-table";

export const TradingSummaryView: React.FC<TradingSummaryViewProps> = ({
  generateSummary,
  tradingSummary,
  downloadReport,
  currencySymbol,
  loading,
  startDate,
  endDate,
}) => {
  return (
    <>
      <TradingSummaryFilter
        generateSummary={generateSummary}
        loading={loading}
        defaultStartDate={startDate}
        defaultEndDate={endDate}
      />
      <TradingSummaryHeader
        startDate={startDate}
        endDate={endDate}
        totalTradedVolume={tradingSummary?.totalTradedVolume ?? 0}
        loading={loading}
        downloadReport={downloadReport}
      />
      <TradingSummaryTable tradingSummary={tradingSummary} loading={loading} currencySymbol={currencySymbol} />
    </>
  );
};
